'use client'

import { Fragment, useState } from 'react'

import cn from 'clsx'

import { Link } from '@/components/Link/Link'
import type { LinkProps } from '@/components/Link/Link'
import { VideoLightBox } from '@/components/VideoLightBox/VideoLightBox'

import css from './VideoButton.module.css'

export interface VideoButtonProps extends LinkProps {
    youtubeVideoId: string
    videoWidth?: number
    videoHeight?: number
    lang: string
    closeLabel: string
}

export function VideoButton({
    youtubeVideoId,
    videoWidth = 1143,
    videoHeight = 643,
    className,
    children,
    lang = 'en',
    closeLabel,
    ...rest
}: VideoButtonProps) {
    const [showVideo, setShowVideo] = useState(false)
    return (
        <Fragment>
            <Link
                icon="video"
                className={cn(css.videoButton, className)}
                onClick={() => setShowVideo(true)}
                {...rest}
            >
                {children}
            </Link>

            {showVideo && (
                <VideoLightBox
                    title=""
                    youtubeVideoId={youtubeVideoId}
                    onClose={() => setShowVideo(false)}
                    width={videoWidth}
                    height={videoHeight}
                    closeLabel={closeLabel}
                    lang={lang}
                />
            )}
        </Fragment>
    )
}
